module.exports = __webpack_public_path__ + "static/media/60570a3f64a1fece44ebf71b43617029.60570a3f.ttf";